/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
export type fetchTradeOnApprovalEligibilityQueryVariables = {
    readonly userId: string;
    readonly itemId: string;
};
export type fetchTradeOnApprovalEligibilityQueryResponse = {
    readonly viewer: {
        readonly item: {
            readonly displayInfo: {
                readonly ctas: {
                    readonly showRequestOnApproval: boolean | null;
                } | null;
            } | null;
        } | null;
    } | null;
};
export type fetchTradeOnApprovalEligibilityQuery = {
    readonly response: fetchTradeOnApprovalEligibilityQueryResponse;
    readonly variables: fetchTradeOnApprovalEligibilityQueryVariables;
};



const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "kind": "LocalArgument",
            "name": "userId",
            "type": "String!",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "itemId",
            "type": "String!",
            "defaultValue": null
        } as any)
    ], v1 = [
        ({
            "kind": "Variable",
            "name": "itemId",
            "variableName": "itemId"
        } as any),
        ({
            "kind": "Literal",
            "name": "pageType",
            "value": "PDP"
        } as any)
    ], v2 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "displayInfo",
        "storageKey": null,
        "args": [
            {
                "kind": "Variable",
                "name": "buyerId",
                "variableName": "userId"
            }
        ],
        "concreteType": "ItemDisplayInfo",
        "plural": false,
        "selections": [
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "ctas",
                "storageKey": null,
                "args": null,
                "concreteType": "CTADisplay",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "showRequestOnApproval",
                        "args": null,
                        "storageKey": null
                    }
                ]
            }
        ]
    } as any), v3 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
    } as any);
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "fetchTradeOnApprovalEligibilityQuery",
            "type": "RootQueryType",
            "metadata": null,
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "viewer",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "item",
                            "storageKey": null,
                            "args": (v1 /*: any*/),
                            "concreteType": "Item",
                            "plural": false,
                            "selections": [
                                (v2 /*: any*/)
                            ]
                        }
                    ]
                }
            ]
        },
        "operation": {
            "kind": "Operation",
            "name": "fetchTradeOnApprovalEligibilityQuery",
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "viewer",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "item",
                            "storageKey": null,
                            "args": (v1 /*: any*/),
                            "concreteType": "Item",
                            "plural": false,
                            "selections": [
                                (v2 /*: any*/),
                                (v3 /*: any*/)
                            ]
                        },
                        (v3 /*: any*/)
                    ]
                }
            ]
        },
        "params": {
            "operationKind": "query",
            "name": "fetchTradeOnApprovalEligibilityQuery",
            "id": "app-buyer-finding/231.0.0-2019-09-03T18:57:24.459Z/fetchTradeOnApprovalEligibilityQuery",
            "text": null,
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = '8e58062f33a319a85a563f132b183fe4';
export default node;
